// Internal Module Imports
import { BASE_URL_BIDDING_SERVICE } from '../../../constants';
import { HttpClient } from '../../../utils/httpClient';

const PATH = {
    getBidRequestForDate: `/${BASE_URL_BIDDING_SERVICE}/admin/bid-request`,
    masterBidding: `/${BASE_URL_BIDDING_SERVICE}/admin/bid-request/master-bidding`,
    delete: `/${BASE_URL_BIDDING_SERVICE}/admin/bid-request`,
    updateStatus: `/${BASE_URL_BIDDING_SERVICE}/admin/bid-request`,
};

const GetBidRequestForDate = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.getBidRequestForDate}`, { params }).then(callback).catch(error).finally(next);
};

const GetBidRequest = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.masterBidding}`, { params }).then(callback).catch(error).finally(next);
};

const DeleteBidRequest = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.delete}/${id}`).then(callback).catch(error).finally(next);
};

const UpdateBidRequestStatus = (id, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.updateStatus}/${id}`).then(callback).catch(error).finally(next);
};

export const AdminBidRequestService = {
    GetBidRequestForDate,
    GetBidRequest,
    DeleteBidRequest,
    UpdateBidRequestStatus,
};
